// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"494d575a","455":"407efb64"}[chunkId] + ".chunk.js";
};